import DownloadIcon from "@/assets/icons/DownloadIcon.svg";
import CopyIcon from "@/assets/icons/CopyIcon.svg";
import { useAppSelector } from "@/redux/hooks/hooks";
import { useGetTransactionsQuery } from "@/redux/feature/creatorBalance/creatorBalanceApi";
import { TTransaction } from "@/redux/feature/creatorBalance/creatorBalanceTypes";
import { formatDate } from "@/utils/formateData";
import { useGlobalContext } from "@/context/GlobalContext";

const BillingHistory = () => {
  const email = useAppSelector((state) => state.auth.user?.email);
  const { data } = useGetTransactionsQuery({ email: email }, { skip: !email });
  const transactions = data?.data?.data;

  return (
    <div>
      <div className="hidden md:block border border-[#DEE1E7] rounded-xl overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[#DEE1E7]">
              <TableHeader title="Invoice name" />
              <TableHeader title="Date" />
              <TableHeader title="Amount" />
              <TableHeader title="Download" />
            </tr>
          </thead>
          <tbody>
            {transactions?.map((invoice: TTransaction, index: number) => (
              <DesktopInvoiceRow key={index} invoice={invoice} />
            ))}
          </tbody>
        </table>
      </div>
      {/*Mobile */}
      <div className="md:hidden border border-[#DEE1E7] rounded-xl px-3 space-y-4">
        {transactions?.map((invoice: TTransaction, i: number) => (
          <MobileInvoiceRow key={i} invoice={invoice} />
        ))}
      </div>
    </div>
  );
};

export default BillingHistory;

interface TableHeaderProps {
  title: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({ title }) => (
  <th className="text-left text-[#97979B] text-sm leading-5 tracking-[-3%] font-medium p-5">
    {title}
  </th>
);

// Table row
interface InvoiceRowProps {
  invoice: TTransaction;
}

const DesktopInvoiceRow: React.FC<InvoiceRowProps> = ({ invoice }) => {
  const { ucdT } = useGlobalContext();
  return (
    <tr>
      <TableCell>
        <div className="flex items-center gap-2">
          <CopyIcon />
          <span className="text-[#1D2939] text-sm leading-5 tracking-[-1.5%] font-medium">
            {invoice.details}
          </span>
        </div>
      </TableCell>
      <TableCell>{formatDate(invoice.createdAt)}</TableCell>
      <TableCell>
        {ucdT?.symbols || "₹"}
        {invoice.amount}
      </TableCell>
      <TableCell>
        <div className="flex items-center justify-between">
          {/* <span>{invoice.plan}</span> */}
          <DownloadIcon />
        </div>
      </TableCell>
    </tr>
  );
};

// Table header data
interface TableCellProps {
  children: React.ReactNode;
}

// Table body data
const TableCell: React.FC<TableCellProps> = ({ children }) => (
  <td className="text-[#344054] text-sm leading-5 tracking-[-1.5%] font-medium p-5">
    {children}
  </td>
);

// Mobile Card

const MobileInvoiceRow: React.FC<InvoiceRowProps> = ({ invoice }) => {
  const { ucdT } = useGlobalContext();
  return (
    <div className="border-b border-[#DEE1E7] py-5">
      <div className="flex items-center justify-between">
        <div className="flex gap-2 items-center">
          <CopyIcon />
          <span className="text-[#1D2939] text-sm leading-5 tracking-[-1.5%] font-medium">
            {invoice.details}
          </span>
        </div>
        {/* <DownloadIcon /> */}
      </div>
      <div className="flex items-center justify-between mt-3">
        <p className="text-[#667085] text-sm leading-5 tracking-[-1.5%] font-medium">
          {formatDate(invoice.createdAt)}
        </p>
        <div className="bg-[#D0D5DD] h-3 w-[2px]"></div>
        <p className="text-[#667085] text-sm leading-5 tracking-[-1.5%] font-medium">
          {ucdT?.symbols || "₹"}
          {invoice.amount}
        </p>
        <div className="bg-[#D0D5DD] h-3 w-[2px]"></div>
        <p className="text-[#667085] text-sm leading-5 tracking-[-1.5%] font-medium">
          {/* {invoice.plan} */}
        </p>
      </div>
    </div>
  );
};
